import React, { Component } from 'react';

import Immutable, {Range} from 'immutable';
import { firebaseRoot, snapshotMap, snapshotToArray, snapshotToDeepArray } from '../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route } from 'react-router';
import TouchButton from '../../components/TouchButton';
import Loader from '../../components/Loader/Loader';
import TouchLink from '../../components/TouchLink';
import LinkTR from '../../components/LinkTR';
import MathMarkup from '../../components/MathMarkup/MathMarkup';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import Input from 'react-bootstrap/lib/Input';
import Static from 'react-bootstrap/lib/FormControls/Static';
import Grid from 'react-bootstrap/lib/Grid';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import Modal from 'react-bootstrap/lib/Modal';
import DeepLinkedStateMixin from 'react-deep-link-state';
import update from 'react-addons-update';
import Lazy from 'lazy.js';
import Mousetrap from 'react-mousetrap-mixin';
import deepEqual from 'deep-equal';
import Promise from 'bluebird';


const StepRow = React.createClass({
    mixins: [ReactFireMixin],

    getInitialState() {
        let okStyle = 'rgba(0,128,0, 0.3)';
        let markedStyle = 'rgba(255,115,0, 0.3)';
        let noopStyle = 'rgba(0,0,0, 0)';
        return {
            step: this.props.step,
            reviewStarted: false,
            okStyle: okStyle,
            markedStyle: markedStyle,
            noopStyle: noopStyle,
            stepStyle: {
                logic: noopStyle,
                gui: noopStyle,
                operation: noopStyle,
                answer: noopStyle,
                hint: noopStyle
            }
        };
    },

    stepValueLink(name) {
        return {
            value: this.props.step[name],
            requestChange: newValue => {
                this.props.step[name] = newValue;
                this.props.onChange(this.props.step);
            }
        };
    },

    onStepClick(name){
        return; // TODO(dunfalk): review on step level is not fully implemented yet

        let stepStyle = this.state.stepStyle;

        if (this.state.stepStyle[name] == this.state.noopStyle) {
            stepStyle[name] = this.state.markedStyle
        }
        else if (this.state.stepStyle[name] == this.state.markedStyle) {
            stepStyle[name] = this.state.okStyle;
        }
        else {
            stepStyle[name] = this.state.noopStyle;
        }
        this.setState({stepStyle: stepStyle});
    },

    onLogicClick(){
        this.onStepClick("logic");
    },

    onGuiClick(){
        this.onStepClick("gui");
    },

    onOperationClick(){
        this.onStepClick("operation");
    },

    onAnswerClick(){
        this.onStepClick("answer");
    },

    onHintClick(){
        this.onStepClick("hint");
    },

    render() {
        const step = this.props.step;
        return <tr>
            <td style={{backgroundColor: this.state.stepStyle.logic}}
                onClick={this.onLogicClick}>
                {step.logic}
            </td>
            <td style={{backgroundColor: this.state.stepStyle.gui}}
                onClick={this.onGuiClick}>
                {step.gui}
            </td>
            <td style={{backgroundColor: this.state.stepStyle.operation}}
                onClick={this.onOperationClick}>
                <MathMarkup>{step.operation}</MathMarkup>
            </td>
            <td style={{backgroundColor: this.state.stepStyle.answer}}
                onClick={this.onAnswerClick}>
                {step.answer}
            </td>
            <td style={{backgroundColor: this.state.stepStyle.hint}}
                onClick={this.onHintClick}>
                <MathMarkup>{step.hint}</MathMarkup>
            </td>
            <td>
                <Input type="textarea" style={{display: "none", width: 150}} rows="2"
                       valueLink={this.stepValueLink('stepReview')}/>
            </td>
        </tr>;
    }
});

const StepsView = React.createClass({
    setStep(index, newStep) {
        const steps = this.props.steps;
        steps[index] = newStep;
        this.props.onChange(steps);
    },

    render() {
        const steps = this.props.steps;

        if (!steps) {
            return <div>No steps defined yet.</div>;
        }

        return <table className="table table-hover">
            <thead>
            <tr>
                <th>Logic</th>
                <th>GUI</th>
                <th>Operation</th>
                <th>Answer</th>
                <th>Hint</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            {steps.map((step, i) => {
                return <StepRow key={i} step={step} onChange={this.setStep.bind(this, i)}/>;
            })}
            </tbody>
        </table>;
    }
});

const ExerciseReview = React.createClass({
    mixins: [
        ReactFireMixin
    ],

    contextTypes: {
        history: React.PropTypes.object.isRequired
    },

    rebind(props) {
        const {params} = props;

        if (props.params.exerciseId) {
            this.bindAsDataSnapshot(
                firebaseRoot.child('admin/base/exercises')
                    .child(params.bookId)
                    .child(params.chapterId)
                    .child(params.subchapterId)
                    .child(params.exerciseId),
                'exercise');
            this.bindAsDataSnapshot(
                firebaseRoot.child('admin/steps')
                    .child(params.bookId)
                    .child(params.chapterId)
                    .child(params.subchapterId)
                    .child(params.exerciseId),
                'steps');
            // Bind two exercises, this and the next one, this is so that we can get the next one but I just
            // don't know how to only get the next one.
            this.bindAsDataSnapshot(
                firebaseRoot.child('admin/base/exercises')
                    .child(params.bookId)
                    .child(params.chapterId)
                    .child(params.subchapterId),
                'exercises');

            this.bindAsDataSnapshot(
                firebaseRoot.child('admin/reviews/exercises')
                    .child(params.bookId)
                    .child(params.chapterId)
                    .child(params.subchapterId)
                    .child(params.exerciseId),
                'baseReview');

        } else {
            this.unbind('exercise');
            this.unbind('exercises');
            this.unbind('steps');
            this.unbind('baseReview');
        }
    },

    componentWillMount() {
        this.setStateAsync = Promise.promisify(this.setState);
        this.rebind(this.props);
    },

    gotoExercise(exercise) {
        if (!exercise) {
            return;
        }

        const {params} = this.props;
        this.context.history.pushState(null,
            `/admin/book/${params.bookId}/${params.chapterId}/${params.subchapterId}/${exercise.key()}`, null);
    },

    baseReviewValueLink() {
        return {
            value: this.state.baseReview.val(),
            requestChange: newValue => {
                if (newValue) {
                    this.state.baseReview.ref().set(newValue);
                }
                else {
                    this.state.baseReview.ref().remove();
                }
            }
        };
    },

    render() {
        if (!this.areAllBindingsLoaded()) {
            return <div>Loading...</div>;
        }

        let markedStyle = 'rgba(255,115,0, 0.3)';
        let okStyle = 'rgba(0,128,0, 0.3)';
        let reviewStyle = okStyle;
        if (this.state.baseReview && this.state.baseReview.exists()) {
            reviewStyle = markedStyle;
        }

        const {exercise, steps} = this.state;

        const exercises = snapshotToArray(this.state.exercises);
        const i = exercises.map(e => e.key()).indexOf(this.props.params.exerciseId);
        const prevExercise = exercises[i - 1];
        const nextExercise = exercises[i + 1];

        return (
            <div>
                <Mousetrap mousetrap={{
                  'ctrl+n': this.gotoExercise.bind(this, nextExercise),
                  'ctrl+p': this.gotoExercise.bind(this, prevExercise)
                }}/>

                <ButtonToolbar>
                    <TouchButton onClick={this.props.onDone} tabIndex={-1}>Done</TouchButton>

                    {prevExercise && <TouchButton onClick={this.gotoExercise.bind(this, prevExercise)}>
                        <Glyphicon glyph="arrow-left"/>&nbsp;Goto <u>p</u>revious</TouchButton>}
                    {nextExercise && <TouchButton onClick={this.gotoExercise.bind(this, nextExercise)}>
                        <Glyphicon glyph="arrow-right"/>&nbsp;Goto <u>n</u>ext</TouchButton>}
                </ButtonToolbar>

                <div style={{backgroundColor: reviewStyle, display: "flex"}}>
                    <div style={{flex: "1"}}>
                        <Static label="Text">
                            <MathMarkup>{exercise.child('text').val()}</MathMarkup>
                        </Static>
                    </div>
                    <div style={{flex: "1"}}>
                        Review notes<Input type="textarea" style={{width: 350}} rows="4"
                                           valueLink={this.baseReviewValueLink("baseReview")}/>
                    </div>
                </div>

                <StepsView steps={snapshotToDeepArray(steps)}/>
            </div>
        );
    }
});

export default ExerciseReview;



/** WEBPACK FOOTER **
 ** ./src/admin/screens/ExerciseReview.js
 **/